import { Image, Video, Cube, Music, MessageSquare, Zap } from 'lucide-react'

// Example prompts for different media types
export const examples = {
  image: [
    'Hyperrealistic portrait of Batman walking a corgi in Central Park, professional photography',
    'Cyberpunk cityscape with neon lights and flying cars, digital art, 8K',
    'Surreal landscape with floating islands and waterfalls, dreamlike atmosphere, matte painting',
    'Photorealistic astronaut riding a dinosaur on Mars, cinematic lighting',
    'Steampunk mechanical butterfly with intricate gears and brass details, macro photography',
  ],
  video: [
    'A corgi surfing on ocean waves with a tiny surfboard, slow motion',
    'Time-lapse of a blooming flower garden from sunrise to sunset',
    'Drone flythrough of an ancient temple hidden in a misty jungle',
    'Animated logo reveal with particle effects and glowing elements',
    'Cyberpunk street scene with rain and neon reflections, cinematic style',
  ],
  '3d': [
    'Low-poly stylized fox character with animation rig',
    'Photorealistic 3D model of a vintage pocket watch with moving parts',
    'Sci-fi helmet with glowing visor and weathered metal texture',
    'Fantasy castle on a floating island with detailed architecture',
    'Futuristic hover bike with glowing engine effects and detailed cockpit',
  ],
  audio: [
    "M83's 'Midnight City' mixed with Michael Jackson's vocals, electronic style",
    'Ambient soundscape with ocean waves and gentle piano melody',
    'Epic orchestral theme with choir and dramatic percussion',
    'Lo-fi hip hop beat with jazz samples and vinyl crackle',
    'Futuristic sound design for a sci-fi door opening mechanism',
  ],
  chatgpt: [
    'Write a poem about the internet in the style of Edgar Allan Poe',
    'Explain quantum computing to a 10-year-old',
    'Create a detailed D&D character backstory for a tiefling bard',
    'Write a marketing email for a new fitness app',
    'Develop a 7-day meal plan for a vegetarian athlete',
  ],
  claude: [
    'Write a poem about the internet in the style of Edgar Allan Poe',
    'Create a detailed business plan for a virtual reality arcade',
    'Explain the process of photosynthesis using a cooking analogy',
    'Write dialogue between two time travelers meeting in ancient Rome',
    'Design a unique magic system for a fantasy novel with clear rules',
  ],
}

// Map of media types to their icons
export const mediaIcons = {
  image: Image,
  video: Video,
  '3d': Cube,
  audio: Music,
  chatgpt: MessageSquare,
  claude: MessageSquare,
  default: Zap,
}
